/*
 * *****************************************************************************
 * File: header.js (/src/components/header.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Sunday, 14th March 2021 12:26:29 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Wednesday, 31st March 2021 4:14:09 pm
 * *****************************************************************************
 */
import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import styled from '@emotion/styled'

import { ReactComponent as VeicoloSVG } from '../assets/images/veicolo.svg'

const Header = () => {
    const isApi = useRouteMatch('/auth/*')
    return (
        <Container>
            <Inner isApi={isApi}>
                <Logo>
                    <VeicoloSVG alt='Logo Veicolo' />
                    <AppTitle>Veicolo</AppTitle>
                </Logo>
                {!isApi && (
                    <Navigation>
                        <ul>
                            <li>
                                <Link to='/'>Veicolo: info targa</Link>
                            </li>
                            <li>
                                <Link to='/termini-servizio'>
                                    Termini di Servizio
                                </Link>
                            </li>
                            <li>
                                <Link to='/privacy-policy'>Privacy Policy</Link>
                            </li>
                        </ul>
                    </Navigation>
                )}
            </Inner>
        </Container>
    )
}
export default Header

const Container = styled.header`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 100%;
    @media (max-width: 768px) {
        height: auto;
    }
`

const Inner = styled.div`
    ${props =>
        props.isApi
            ? `
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `
            : `
        display: grid;
        grid-template-columns: 1fr 9fr;
    `};
    height: 100px;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    max-width: 1280px;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        height: auto;
    }
`

const AppTitle = styled.div`
    color: #ffffff;
    font-weight: 900;
    margin-left: 15px;
    font-size: 50px;
    font-family: 'Advent Pro', 'Open Sans', sans-serif;
`

const Logo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    & svg {
        width: 70px;
        height: 70px;
    }
`

const Navigation = styled.nav`
    width: 100%;
    height: calc(100% - 30px);
    position: relative;
    & ul {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 100%;
        padding: 0;
        & li {
            position: relative;
            display: block;
            margin-left: 15px;
            font-weight: 600;
            border-radius: 7px;
            background: linear-gradient(
                135deg,
                rgba(67, 150, 199, 1) 0%,
                rgba(42, 94, 185, 1) 100%
            );
            font-size: 14px;
            transition: all 0.1s linear;
            text-align: center;
            & a {
                display: block;
                padding: 8px 15px;
                text-decoration: none;
                color: #ffffff;
                transition: all 0.1s linear;
            }
        }
        & li::before {
            position: absolute;
            content: '';
            background: linear-gradient(
                135deg,
                rgba(67, 150, 199, 1) 0%,
                rgba(42, 94, 185, 1) 100%
            );
            top: -1px;
            left: -1px;
            bottom: -1px;
            right: -1px;
            z-index: -1;
            border-radius: 7px;
            box-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
        }
        & li:hover {
            background: #f2f1f6;
            & a {
                color: #2a5eb9;
            }
        }
    }
    @media (max-width: 768px) {
        height: auto;
        & ul {
            justify-content: center;
            & li {
                margin-left: 5px;
                margin-right: 5px;
            }
        }
    }
`
